import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var HeaderHelper =
/*#__PURE__*/
function () {
  function HeaderHelper() {
    _classCallCheck(this, HeaderHelper);

    /**
    * Header name for SDK usage
    */
    this.sdkVersionHeader = 'X-KC-SDKID';
  }
  /**
  * Header identifying SDK type & version for internal purposes of Kontent.ai
  */


  _createClass(HeaderHelper, [{
    key: "getSdkIdHeader",
    value: function getSdkIdHeader(info) {
      return {
        header: this.sdkVersionHeader,
        value: "".concat(info.host, ";").concat(info.name, ";").concat(info.version)
      };
    }
  }]);

  return HeaderHelper;
}();
export var headerHelper = new HeaderHelper();